module.exports = __webpack_public_path__ + "img/11088021_L.e9f4a14e.png";